import { createReducer, on } from '@ngrx/store';
import {
  loadTags,
  loadTagsFail,
  loadTagsSuccess,
} from '../actions/tags.actions';

export interface Tag {
  id: number;
  name: string;
  type: string;
}

export interface TagsState {
  tags: Tag[];
  // FIXME: unused
  loadingTags: boolean;
  // FIXME: unused
  loadedTags: boolean;
}

const initialState: TagsState = {
  tags: [],
  loadingTags: false,
  loadedTags: false,
};

export const reducer = createReducer(
  initialState,
  on(
    loadTags,
    (state): TagsState => ({
      ...state,
      loadingTags: true,
      loadedTags: false,
    }),
  ),
  on(loadTagsSuccess, (state, { payload: tags }): TagsState => {
    return {
      ...state,
      loadingTags: false,
      loadedTags: true,
      tags,
    };
  }),
  on(loadTagsFail, (state): TagsState => {
    return { ...state, loadingTags: false, loadedTags: false };
  }),
);

export const TAGS_STORE_KEY = 'TagsState';
